function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "EditIcon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "EditIcon",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Edit-/-Alt-2",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit-alt-2",
  transform: "translate(0.000000, -3.333333)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.6666667,83.3333891 L3.33333333,83.3333891 C1.49238417,83.3333891 -5.57875983e-05,81.8409492 -5.57875983e-05,80 L-5.57875983e-05,66.6666667 C-0.00512252933,65.7806567 0.342711619,64.9290628 0.966666667,64.3 L58.2,7.06666667 C63.1889723,2.07769461 71.2776943,2.07769469 76.2666665,7.06666686 C81.2556386,12.055639 81.2556387,20.1443611 76.2666667,25.1333333 L19.0333333,82.3666667 C18.4042706,82.9906217 17.5526766,83.3384559 16.6666667,83.3333891 Z M6.66666667,76.6666667 L15.3,76.6666667 L71.5333333,20.4 C73.3012886,18.6679642 73.8398316,16.0356159 72.8941593,13.7484085 C71.948487,11.4612011 69.7082314,9.97777914 67.2333333,9.99975376 C65.6144573,9.98824317 64.0610767,10.6384955 62.9333333,11.8 L6.66666667,68.0333333 L6.66666667,76.6666667 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.3333333,31.6667225 C67.4473234,31.6717892 66.5957294,31.323955 65.9666667,30.7 L54.3,19.0333333 C52.9929261,17.7262594 52.9929261,15.6070739 54.3,14.3 C55.6070739,12.9929261 57.7262594,12.9929261 59.0333333,14.3 L70.7,25.9666667 C71.3310422,26.5925553 71.6859944,27.4445415 71.6859944,28.3333333 C71.6859944,29.2221251 71.3310422,30.0741113 70.7,30.7 C70.0709372,31.323955 69.2193433,31.6717892 68.3333333,31.6667225 Z",
  id: "Path"
}))));

var SvgEditIcon = function SvgEditIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EditIcon.66a12ae9.svg";
export { ForwardRef as ReactComponent };